const trustItems = [
  {
    icon: 'ri-shield-check-line',
    title: 'Verified Links',
    description: 'Every link in our spreadsheet goes through a verification process to ensure quality and reliability.',
  },
  {
    icon: 'ri-group-line',
    title: 'Community Picks',
    description: 'Products are curated and recommended by a community of experienced Pandabuy shoppers worldwide.',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Updated Daily',
    description: 'Our spreadsheet is refreshed every day with new finds, removing outdated and broken links.',
  },
  {
    icon: 'ri-guide-line',
    title: 'Safety Guides',
    description: 'We provide tips and best practices to help you shop safely and avoid common pitfalls.',
  },
  {
    icon: 'ri-store-2-line',
    title: 'Seller Verification',
    description: 'Sellers are checked for reputation and reliability before their products appear in our lists.',
  },
  {
    icon: 'ri-ship-line',
    title: 'Shipping Tips',
    description: 'Get practical advice on shipping options, costs, and delivery timelines for your orders.',
  },
];

export default function TrustSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 text-xs font-semibold text-accent-700 bg-accent-100 rounded-full mb-4">
            Why Choose Us
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            Why Users Trust Our Pandabuy Spreadsheet
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            We are committed to providing the most reliable and up-to-date Pandabuy shopping resource available.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {trustItems.map((item) => (
            <div
              key={item.title}
              className="flex items-start gap-4 p-5 md:p-6 bg-background-50 border border-background-200/60 rounded-xl"
            >
              <span className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center flex-shrink-0 rounded-xl bg-accent-100 text-accent-600">
                <i className={`${item.icon} text-lg md:text-xl`}></i>
              </span>
              <div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900">{item.title}</h3>
                <p className="mt-1 text-xs md:text-sm text-foreground-600 leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}